/**
 * Base class for all the CloverRequestRecords.
 * Each class in this directory corresponds to a specific Clover API endpoint.
 */
class AbstractCloverRequestRecord {
    constructor(method, url) {
        if (['GET', 'POST', 'PUT', 'DELETE'].includes(method) === false) {
            throw new Error('Unknown or missing HTTP method');
        }
        if (!url) {
            throw new Error('Missing request url');
        }
        this.method = method;
        this.url = url;
    }
}

module.exports = AbstractCloverRequestRecord;
